<ng-template #templateref>
  <div class="modal-confirm">
    <p class="modal-message">
      {{ customMessage || 'Desideri confermare?' }}
    </p>

    <div class="modal-actions">
      <button type="button" class="btn-confirm" (click)="confirm()">Sì</button>
      <button type="button" class="btn-decline" (click)="decline()">No</button>
    </div>
  </div>
</ng-template>
